<script>
import { defineComponent, h, computed, watch } from "vue";
import { Bar } from "vue-chartjs";
import store from "../../store/index";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import StatisticsUtils from "../../utils/statistics.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default defineComponent({
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
  },
  setup(props) {
    const chartDataStore = computed({
      get: () => store.state.statistics.barChartData,
    });

    watch(chartDataStore, () => {
      if (chartDataStore.value.datasets.length == 0) {
        store.commit("statistics/updateBarChartClicked", false);
      }
    });

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          ticks: {
            callback: function (value) {
              return '€' + Number(parseFloat(value)).toLocaleString('nl-NL');
            },
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || "";
              if (label) {
                label += ": ";
              }
              if (context.parsed.y !== null) {
               label += '€' + Number(parseFloat(context.parsed.y)).toLocaleString('nl-NL');
              }
              return label;
            },
          },
        },
      },
      onClick: (e) => {
        var chart = e.chart;
        var activePoints = chart.getElementsAtEventForMode(
          e,
          "nearest",
          { intersect: true },
          false
        );
        const [{ index }] = activePoints;
        const [{ datasetIndex }] = activePoints;
        const customerName = chartDataStore.value.datasets[datasetIndex].label;
        const yearString = chartDataStore.value.labels[index];
        const yearInt = parseInt(yearString, 10);
        const year = isNaN(yearInt) ? null : yearInt;
        const tableName =
          year == null ? customerName : customerName + " " + year;

        StatisticsUtils.customerSchemes(customerName, year);
        store.commit("statistics/updateBarChartClicked", true);
        store.commit("statistics/setTableName", tableName);
      },
    };

    return () =>
      h(Bar, {
        chartData: chartDataStore.value,
        chartOptions,
        chartId: props.chartId,
        width: props.width,
        height: props.height,
        cssClasses: props.cssClasses,
      });
  },
});
</script>
